import axios from 'axios';
import firebase from 'firebase/compat/app';
import swal from 'sweetalert2';
import { default as config, CONSTANTS } from '../constants/constants';
import { auth } from '../firebase';
import { displayNotification, getCopyrightHtml } from './utils';

export const userRegistrationInCategory = (
  studentId,
  fullname,
  email,
  passwordOne,
  passwordTwo,
  asu,
  history,
  setLoading
) => {
  if (passwordOne !== passwordTwo) {
    swal({
      imageUrl: CONSTANTS.swalLogo,
      title: '<div class="titleModal">Notice</div>',
      html: '<p class="contentModal">Passwords must match.</p>',
      showConfirmButton: false,
      showCloseButton: true,
      background: '#121C24',
      allowOutsideClick: false
    });
  } else {
    let currentUser;
    let token;
    setLoading(true);
    if (asu !== undefined) {
      auth
        .doFetchSignInMethodsForEmail(email)
        .then((result) => {
          if (result.length > 0) {
            setLoading(false);
            return Promise.reject({
              message: 'This email already exists. Please choose another one.'
            });
          } else {
            return auth.doCreateUserWithEmailAndPassword(email, passwordOne);
          }
        })
        .then(() => {
          currentUser = firebase.auth().currentUser;
          if (currentUser) {
            setLoading(false);

            const title = '<div class="titleModal">Welcome to Inflo!</div>';
            const message =
              '<p class="contentModal">Please check your email inbox and click the link in the email you received to confirm your registration.</p>' +
              getCopyrightHtml();
            displayNotification(message, {
              title,
              showConfirmButton: false,
              showCloseButton: false,
              allowOutsideClick: false
            });

            currentUser.sendEmailVerification();
            return currentUser.getIdToken();
          } else {
            setLoading(false);
            return Promise.reject({ message: 'User not found' });
          }
        })
        .then((_token) => {
          token = _token;
          firebase.auth().currentUser.updateProfile({
            displayName: fullname
          });
          return firebase.auth().currentUser.getIdToken();
        })
        .then((_token) => {
          token = _token;
          const options = {
            method: 'POST',
            headers: { 'X-Firebase-Auth': token },
            url: `${config.serverURL}/auth/user/asu`,
            data: {
              code: asu,
              studentId
            }
          };
          return axios(options);
        })
        .then(() => {
          firebase.auth().signOut();
          history.push('/');
        })
        .catch((error) => {
          setLoading(false);
          swal({
            imageUrl: CONSTANTS.swalLogo,
            title: '<div class="titleModal">Error</div>',
            html: `<p class="contentModal">${error.message}</p>`,
            showConfirmButton: false,
            showCloseButton: true,
            background: '#121C24',
            allowOutsideClick: false
          });
        });
    }
  }
};

export const displayErrorMessage = (error) => {
  swal({
    imageUrl: CONSTANTS.swalLogo,
    title: '<div class="titleModal">Error</div>',
    html: `<p class="contentModal">${error.message}</p>`,
    showConfirmButton: false,
    showCloseButton: true,
    background: '#121C24',
    allowOutsideClick: false
  }).catch(swal.noop);
};

export const displayEmailPasswordVerification = (currentUser) => {
  swal({
    imageUrl: CONSTANTS.swalLogo,
    title: '<div class="titleModal">Not verified user.</div>',
    html:
      '<p class="contentModal">Please check your email inbox or click the button to receive a new verification email.</p>',
    showConfirmButton: true,
    confirmButtonText: 'Resend',
    showCloseButton: true,
    background: '#121C24',
    allowOutsideClick: false
  })
    .then((result) => {
      if (result) {
        currentUser.sendEmailVerification();
        return currentUser.getIdToken();
      }
    })
    .catch(swal.noop);
};
